import { useQuery, useQueryClient } from '@tanstack/react-query';
import { authApi } from '../api';

export function useAuth() {
  const queryClient = useQueryClient();

  const {
    data: profileData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['auth', 'profile'],
    queryFn: async () => {
      const response = await authApi.getProfile();
      // Backend returns { success, message, data: { email, user_id, is_active } }
      return response.data?.data;
    },
    retry: false,
    staleTime: Number.POSITIVE_INFINITY, // Cache profile indefinitely
  });

  const user = profileData;

  const login = () => {
    // Redirect to backend OAuth flow
    authApi.login();
  };

  const logout = () => {
    // Clear cached profile
    queryClient.setQueryData(['auth', 'profile'], null);
    // Redirect to backend logout
    authApi.logout();
  };

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    error,
    login,
    logout,
  };
}
